// extracted by mini-css-extract-plugin
export default {"melodyVideo":"GO-z","isFullWidth":"HO-z","landingPageVideo":"IO-z","play":"JO-z","iframeVideo":"KO-z","playHidden":"LO-z","fullwidth":"MO-z"};